//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters } from 'vuex';
import { resendVerifyEmail, refreshAccount } from '@motionelements/core/src/services/account.service.js';

export default {
  name: 'UnactivatedAccountFlash',
  components: {
    LoaderSpin: () => import('@motionelements/core/src/components/ui/LoaderSpin.vue'),
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapState({
      userLoading: state => state.user.loading,
    }),
    ...mapGetters({
      isLoggedInButUnactivated: 'user/isLoggedInButUnactivated',
    }),
  },
  created() {
    if (this.isLoggedInButUnactivated) {
      refreshAccount();
    }
  },
  methods: {
    resendVerify() {
      this.loading = true;
      resendVerifyEmail()
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
